<template>
    <v-container fluid class="pa-5">
        <ShippingLabelCampaignPositionGoodsDialog
            :is-open="goodsDialog"
            :is-editable="true"
            :position-goods="firstPackageGoods"
            @on-save="updateData"
            @on-close="closeAddGoodsDialog"
        />

        <v-row justify="end" dense>
            <v-col cols="12">
                <v-row align="center">
                    <v-col cols="auto">
                        <strong>Towary</strong>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                            v-if="packageIndex !== 0"
                            color="secondary"
                            fab
                            x-small
                            class="elevation-1"
                            data-sentry-label="Dodaj pakiety na paletę"
                            @click="showAddGoodsDialog()"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :items="items"
                    :headers="packageHeaders"
                    disable-pagination
                    sort-by="goodName"
                    :mobile-breakpoint="0"
                    hide-default-footer
                >
                    <template #item.name="{item}">
                        <span>
                            {{ item.goodName }}
                        </span>
                    </template>
                    <template #item.code="{item}">
                        <span>
                            {{ parseEmptyValue(item.goodCode) }}
                        </span>
                    </template>
                    <template #item.index="{item}">
                        <span>
                            {{ parseEmptyValue(item.index) }}
                        </span>
                    </template>
                    <template #item.amount="{item}">
                        <span>
                            {{ item.amount }}
                        </span>
                    </template>
                    <template #item.description="{item}">
                        <span>
                            {{ parseEmptyValue(getDescription(item)) }}
                        </span>
                    </template>
                    <template #item.actions="{item}">
                        <div class="d-inline-flex">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Drukuj etykietę zestawu"
                                        :disabled="item.hasChanges"
                                        v-on="on"
                                        @click="printProduct(item)"
                                    >
                                        <v-icon color="green">
                                            mdi-printer
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Drukuj etykietę zestawu</span>
                            </v-tooltip>
                            <v-tooltip
                                v-if="packageIndex !== 0"
                                :open-delay="tooltipDelay"
                                top
                            >
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Usuń towar"
                                        v-on="on"
                                        @click="removeGood(item)"
                                    >
                                        <v-icon color="pink">
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Usuń towar</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'ShippingLabelCampaignPositionPackageGood',
    components: {
        ShippingLabelCampaignPositionGoodsDialog: () => import('./Dialogs/ShippingLabelCampaignPositionGoodsDialog.vue'),
    },
    mixins: [
        parse,
        tooltipDelay,
    ],
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        packageIndex: {
            type: Number,
            default: null
        },
        positionIndex: {
            type: Number,
            default: null
        },
        firstPackageGoods: {
            type: Array,
            default: () => [],
        },
        labelPosition: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            goodsDialog: false,
            packageHeaders: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    align: 'left',
                    sortable: false,
                    width: 300,
                    showOnRead: true
                },
                {
                    text: 'Kod EAN',
                    value: 'code',
                    align: 'center',
                    sortable: false,
                    width: 120,
                    showOnRead: true
                },
                {
                    text: 'Indeks',
                    value: 'index',
                    align: 'center',
                    sortable: false,
                    width: 100,
                    showOnRead: true
                },
                {
                    text: 'Ilość',
                    value: 'amount',
                    align: 'center',
                    sortable: false,
                    width: 50,
                    showOnRead: true
                },
                {
                    text: 'Opis',
                    value: 'description',
                    align: 'center',
                    sortable: false,
                    width: 70,
                    showOnRead: true
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 80,
                    showOnRead: false
                }
            ],
        }
    },
    methods: {
        printProduct(item) {
            this.$emit('on-print', item)
        },
        showAddGoodsDialog() {
            this.goodsDialog = true
        },
        closeAddGoodsDialog() {
            this.goodsDialog = false
        },
        updateData(newPackageGoods, updatedOriginalGoods) {
            this.$emit('on-update', newPackageGoods, updatedOriginalGoods)
        },
        setDescription(item) {
            const packagesWithGood = this.labelPosition.shippingLabelPositionPackages
                .filter(pkg => pkg.shippingOrderPositionPackageGoods.some(good => good.goodId === item.goodId))
            const totalPackages = packagesWithGood.length
            const goodPosition = packagesWithGood.findIndex(pkg => pkg === this.labelPosition.shippingLabelPositionPackages[this.packageIndex]) + 1
            
            item.description = `${goodPosition} z ${totalPackages}`
        },
        getDescription(item) {
            this.setDescription(item)

            return item.description
        },
        removeGood(item) {
            item.hasChanges = true
            this.$emit('on-delete', item)
        },
    },
}
</script>